// extracted by mini-css-extract-plugin
export default {"number":"NumberText__number___wLbKV"};